import React from 'react';
import PropTypes from 'prop-types';
import FieldItem from '../FieldItem/FieldItem';

var LoopingItemsComponent = function LoopingItemsComponent(_ref) {
  var member = _ref.member,
      loopingGroup = _ref.loopingGroup,
      uploadingFiles = _ref.uploadingFiles,
      files = _ref.files,
      handleChange = _ref.handleChange,
      allFormFields = _ref.allFormFields,
      country = _ref.country,
      language = _ref.language;
  return loopingGroup.fields.map(function (field, fieldIndex) {
    return React.createElement(FieldItem, {
      key: fieldIndex,
      id: "".concat(member, ".").concat(field.id),
      arrayMember: member,
      fieldTitle: field.fieldTitle,
      condition: field.conditionPostfix,
      restrictionValidation: field.restrictionValidation,
      handleChange: handleChange,
      fieldType: field.formType,
      required: field.required,
      note: field.note,
      listValues: field.listValues,
      uploadingFiles: uploadingFiles,
      files: files,
      fields: allFormFields,
      country: country,
      language: language
    });
  });
};

LoopingItemsComponent.propTypes = {
  member: PropTypes.string.isRequired,
  loopingGroup: PropTypes.object.isRequired,
  country: PropTypes.string,
  language: PropTypes.string
};
export default LoopingItemsComponent;